"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationTeamRoleSummary = exports.OrganisationTeamRoleSummaryDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var label_1 = require("../elements/label");
var link_1 = require("../elements/link");
var organisation_logo_1 = require("./organisation-logo");
var use_entities_1 = require("../../hooks/use-entities");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
exports.OrganisationTeamRoleSummaryDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-transform: uppercase;\n    color: ", ";\n    font-weight: 400;\n  "], ["\n    text-transform: uppercase;\n    color: ", ";\n    font-weight: 400;\n  "])), theme_1.theme.COLOR('text-mid'))
});
var LogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 90%;\n    margin-top: ", ";\n    &:hover {\n      img {\n        filter: brightness(1.15);\n      }\n    }\n  "], ["\n    max-width: 90%;\n    margin-top: ", ";\n    &:hover {\n      img {\n        filter: brightness(1.15);\n      }\n    }\n  "])), theme_1.theme.UNIT(4))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-shrink: 1;\n    margin-right: 16px;\n    padding: 4px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    ", "\n  "], ["\n    flex-shrink: 1;\n    margin-right: 16px;\n    padding: 4px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      width: ", ";\n    "], ["\n      width: ", ";\n    "])), props._width);
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: (0, styled_components_1.default)(label_1.Label)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Logo: (0, styled_components_1.default)(organisation_logo_1.OrganisationLogo)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles)
};
var OrganisationTeamRoleSummary = function (props) {
  var className = props.className,
    entity = props.entity;
  var role = entity.role,
    organisation = entity.organisation;
  var entities = (0, use_entities_1.useEntities)();
  var Icons = (0, use_icons_1.useIcons)();
  var t = (0, use_lang_1.useLang)();
  var to = organisation && entities.Organisation && entities.Organisation.to(organisation.slug);
  return react_1.default.createElement(My.Container, {
    className: className
  }, role && role.name && react_1.default.createElement(My.Label, {
    icon: react_1.default.createElement(Icons.BuildingCircle, null)
  }, role.name || t('Organisation'), ":"), react_1.default.createElement(My.Link, {
    to: to
  }, react_1.default.createElement(My.Logo, {
    minHeight: "none",
    maxWidth: "100%",
    entity: organisation
  })));
};
exports.OrganisationTeamRoleSummary = OrganisationTeamRoleSummary;
exports.OrganisationTeamRoleSummary.defaultProps = exports.OrganisationTeamRoleSummaryDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;